export default __webpack_public_path__ + "media/img_02/300@2x-7c7d9188.png";